import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { Form } from "@ui/form/Form";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";
import { GD } from "src/GD";

export const S_ADD_GROUP_POPUP = new Signal<{
	groupID: number;
	clientID: number;
	onChange?: () => void;
} | null>("S_ADD_GROUP_POPUP");

export const AddGroupPopup = () => {
	useLocale();
	const requestData = S_ADD_GROUP_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const [form, setForm] = useState<IClientGroup>();

	useEffect(() => {
		if (requestData) {
			loadGroup();
		}
	}, [requestData]);

	const loadGroup = async () => {
		if (requestData) {
			const res = await GD.REQ_GROUP.request({
				groupID: requestData.groupID,
				clientID: requestData.clientID,
			});

			if (res?.error) {
				setError(res?.error);
			} else if (res?.data) {
				setForm(JSON.parse(JSON.stringify(res.data)));
			}
		}
	};

	if (!requestData) return null;

	const handleSubmit = async () => {
		if (form) {
			setError(undefined);
			setBusy(true);

			const res = await GD.REQ_GROUP_SAVE.request(form);
			if (!res.error) {
				requestData.onChange && requestData.onChange();
				closePopup();
			} else {
				setError(res.error);
			}
			setBusy(false);
		}
	};

	const closePopup = () => {
		S_ADD_GROUP_POPUP.invoke(null);
		setError(undefined);
		setForm(undefined);
	};

	return (
		<Panel
			sx={{
				maxWidth: "1200px",
				height: "80vh",
				padding: "0",
				minWidth: "500px",
			}}
			decorator="absolute"
			busy={busy}
			label={requestData.groupID === -1 ? msg("addNewMerchant") : msg("editGroup_dd5f2d9e")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
				}}>
				<Form
					data={form}
					decorator={[
						{
							direction: "column",
							fields: [
								{
									name: "name",
									label: msg("merchantName"),
								},
								{
									name: "domain",
									label: msg("domain"),
								},
								{
									name: "description",
									label: msg("description"),
								},

								{
									name: "test_user_name",
									label: msg("testName"),
								},
								{
									name: "test_user_password",
									label: msg("password"),
								},
								{
									name: "risk",
									label: msg("highRisk"),
									type: "select",
									options: ["low", "medium", "high"],
								},
							],
						},
					]}
				/>
			</VBox>

			<Spacer size="20px" />

			<VBox sx={{gap: "12px" }}>
				<Error error={error} />
				<Button
					title={msg("submit_155f816c")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
